/**
 * FONT-INVOICE-2026-10-05 — pdfInvoiceV3.js: Invoice V3-ONLY CLONE of pdfInvoice.js.
 *
 * The original pdfInvoice.js is shared with InvoicePDF.js / DownloadInvoicePDF.js
 * (frozen v1/v2 pages), so it must NOT be edited. Only the 2 Invoice V3 components
 * (InvoicePDFInvoiceV3 / DownloadInvoicePDFInvoiceV3, used by InvoiceV3.js ONLY) import
 * this file. Revert = change that one import line back to '../pdfConfig/pdfInvoice'.
 *
 * What differs from the original (client's ask: bigger, readable print; no overlaps):
 *  - Table text +2pt (7.5px -> 10.2px; SKU 6.5px -> 9.2px), same +2pt rule as the SO PDF.
 *  - Column widths re-balanced so Code / SKU / Amount never overlap at the bigger size
 *    (Qty 5.5, Code 16, SKU 15, Description 35, $ 2.5, Price 10, $ 2.5, Amount 12 = 98.5%).
 *    The original summed to 102% and relied on flex shrink.
 *  - Bottom totals block: larger text and a LARGE BOLD "Invoice Total" line.
 * Everything else (header block, boxes, page layout) is identical to the original.
 */
import { StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({

    blockHeaderStyle:{
        width:"100%",
        display: "flex",
        flexDirection: "row",
        

    },

    CompanyTitleStyle:{
        fontSize: "40px",
        color: "gray", 
        left: "20px",
        top:"8px" ,
        marginBottom:"15px"
        
    },
    TypeInvoiceTitle:{
       fontSize: "15px", 
       color: "black", 
       left:"82px",
       top:"15px" ,  
    },
    PageInfoStyle:{
        fontSize: "10px", 
        color: "black",
        top:"10px",
        left:"60px"
    },
    blockHeader:{
        width:"33.33%",
    },
    block50Percent:{
        width:"50%",
    },
    block30Percent:{
        width:"30%",
    },
    block70Percent:{
        width:"70%",
    },
    HeaderTextStyle:{
        fontSize: "8px", 
        left: "33px"
    },
    ColumnaHeader2: {
        width: "45%",
        fontSize: "8px",
        textAlign: "left",
        display: "block",
        color: "#000000"
    },
    ColumnaHeader1: {
        width: "40%",
        fontSize: "8px",
        textAlign: "left",
        display: "block",
        color: "#000000"
    },
    SubContainerHeader: {
        width: "70%",
        marginLeft: "35%",
        display: "flex",
        flexDirection: "row",
        marginBottom: "2px",
        color: "rgb(255, 255, 255)"

    },
    TitleBoxes1:{
        fontSize: "11px",
        left:"35px",
        marginBottom:"2px",
        marginTop:"5px"
    },
    TitleBoxes2:{
        fontSize: "11px",
        left:"25px",
        marginBottom:"2px",
        marginTop:"5px"
    },
    BoxLeft: {
        width:"30%",
        border: '2px',
        borderColor: 'black',
        borderStyle: 'solid',
        minHeight: '10px',
        minWidth: '225px',
        marginLeft:"35px",
        
    },
    BoxRight: {
        width:"30%",
        border: '2px',
        borderColor: 'black',
        borderStyle: 'solid',
        minHeight: '10px',
        minWidth: '225px',
        marginLeft:"62px"
    },

    TextStyleInHeaderBoxes:{
        fontSize: "11px",
        marginLeft:"3px"      
    },
    Table1Style:{
        marginLeft:"6%",
        marginRight:"6%",
        marginTop:"2px",
        width:"88%",
        borderColor: 'black',
        borderStyle: 'solid',
        borderBottom: '1.5px',
        borderTop:'1.5px',
        fontSize: "11px",
        
    },
    block22Percent:{
        width:"22%",
        display: "block",
        marginBottom:"5px"
    },
    block22PercentHeader:{
        width:"22%",
        display: "block",
        
    },
    Table1File:{
        width:"100%",  
        display: "flex",
        flexDirection: "row",
        
    },
    Table: {
        width: "88%",
        marginLeft: "6%",
        marginTop: "9px",

    },

    CabeceraTabla: {
        width: "100%",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        textAlign: "center",
        display: "flex",
        flexDirection: "row",
        borderBottom: '2px',
        borderTop:'2px',
        borderRight:'2px',
        borderColor: 'black',
        borderStyle: 'solid',
    },
    ColumnaCantidadesHeader: {

        width: "5.5%",
        fontSize: "10.2px",
        textAlign: "center",
        display: "block",
        borderLeft: '2px',
        borderColor: 'black',
        borderStyle: 'solid',
   
    },
    ColumnaCantidades: {
        width: "5.5%",
        fontSize: "10.2px",
        textAlign: "center",
        display: "block",
        borderLeft: '2px',
        borderBottom:'1px',
        borderColor: 'black',
        borderStyle: 'solid',
        
    },
    ColumnaCantidadesClear: {
        width: "5.5%",
        fontSize: "10.2px",
        textAlign: "center",
        display: "block",
        borderLeft: '2px',
        borderColor: 'black',
        borderStyle: 'solid',
        
    },
    ColumnaCantidadesBottom: {
        width: "5.5%",
        fontSize: "10.2px",
        textAlign: "center",
        display: "block",

    },
    ColumnaNormalHeader: {
        fontSize: "10.2px",
        width: "16%",
        textAlign: "center",
        display: "block",

    },
    ColumnaNormal: {
        fontSize: "10.2px",
        width: "16%",
        textAlign: "left",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",
        borderBottom:"1px"
 
    },
    ColumnaNormalClear: {
        fontSize: "10.2px",
        width: "16%",
        textAlign: "left",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",
 
    },
    ColumnaNormalBottom: {
        fontSize: "10.2px",
        width: "16%",
        textAlign: "center",
        display: "block",

    },

    ColumnaNormal2Header: {
        fontSize: "10.2px",
        width: "18%",
        textAlign: "center",
        display: "block",

    },
    ColumnaNormal2: {
        fontSize: "10.2px",
        width: "18%",
        textAlign: "left",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",
        borderBottom:"1px"
 
    },


    ColumnaNormal2Bottom: {
        fontSize: "10.2px",
        width: "18%",
        textAlign: "center",
        display: "block",

    },

    ColumnaNormal2Clear: {
        fontSize: "10.2px",
        width: "18%",
        textAlign: "left",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",

 
    },

    ColumnaGrandeHeader: {
        width: "35%",
        fontSize: "10.2px",
        textAlign: "center",
        display: "block",


    },
    ColumnaGrande: {
        width: "35%",
        fontSize: "10.2px",
        textAlign: "left",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",
        borderBottom:"1px"

    },
    ColumnaGrandeClear: {
        width: "35%",
        fontSize: "10.2px",
        textAlign: "left",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",

    },
    ColumnaGrandeBottom: {
        width: "35%",
        fontSize: "10.2px",
        textAlign: "center",
        display: "block",

    },


    ColumnaGrande2Header: {
        width: "60%",
        fontSize: "10.2px",
        textAlign: "center",
        display: "block",


    },
    ColumnaGrande2: {
        width: "60%",
        fontSize: "10.2px",
        textAlign: "left",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",
        borderBottom:"1px"

    },
    ColumnaGrande2Clear: {
        width: "60%",
        fontSize: "10.2px",
        textAlign: "left",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",

    },

    ColumnaMonetariaHeader: {
        width: "10%",
        fontSize: "10.2px",
        textAlign: "left",
        display: "block",
        
 
    },
    ColumnaMonetaria: {
        width: "10%",
        fontSize: "10.2px",
        textAlign: "right",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderBottom:"1px",

    },
    ColumnaMonetariaClear: {
        width: "10%",
        fontSize: "10.2px",
        textAlign: "right",
        display: "block",

    },
    ColumnaMonetariaBottom: {
        width: "10%",
        fontSize: "10.2px",
        textAlign: "center",
        display: "block",
 
    },
    ColumnaMonetariaRightHeader: {
        width: "12%",
        fontSize: "10.2px",
        textAlign: "left",
        display: "block",
        
 
    },
    ColumnaMonetariaRight: {
        width: "12%",
        fontSize: "10.2px",
        textAlign: "right",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderRight:"2px",
        borderBottom:"1px"

    },
    ColumnaMonetariaRightClear: {
        width: "12%",
        fontSize: "10.2px",
        textAlign: "right",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderRight:"2px",

    },

    ColumnaMonetariaRightBottom: {
        width: "12%",
        fontSize: "10.2px",
        textAlign: "center",
        display: "block",
 
    },
    SimboloHeader: {
        width: "2.5%",
        fontSize: "10.2px",
        textAlign: "right",
        display: "block",
  
    },
    Simbolo: {
        width: "2.5%",
        fontSize: "10.2px",
        textAlign: "right",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",
        borderBottom:"1px"
       
    },
    SimboloClear: {
        width: "2.5%",
        fontSize: "10.2px",
        textAlign: "right",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",
       
    },

    SimboloBottom: {
        width: "2.5%",
        fontSize: "10.2px",
        textAlign: "right",
        display: "block",
        
    },
    
    CuerpoTabla: {
        width: "100%",
        textAlign: "center",
        fontSize: "9px",
        
//paddingTop: 50
    },
    CuerpoTablaFinal: {
        width: "100%",
        textAlign: "center",
        fontSize: "9px",
        borderColor: 'black',
        borderStyle: 'solid',
        borderBottom:"2px"
        
//paddingTop: 50
    },
    Fila: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        
    }, FilaBreak: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        paddingTop: "10px"
        
    }
    
    
    ,
    ColumnaNormalCenterHeader: {
        fontSize: "10.2px",
        width: "15%",
        textAlign: "center",
        display: "block",
    
    },
    ColumnaNormalCenter: {
        fontSize: "9.2px",
        width: "15%",
        textAlign: "center",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",
        borderBottom:"1px"
    },
    ColumnaNormalCenterClear: {
        fontSize: "10.2px",
        width: "15%",
        textAlign: "center",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",
        
    },
    ColumnaNormalCenterBottom: {
        fontSize: "10.2px",
        width: "15%",
        textAlign: "center",
        display: "block",
        
    },

    BottomTextStyle:{
        marginTop:"8px",
        fontSize: "8px",
       
    },
    CabeceraBottom: {
        width: "100%",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        textAlign: "center",
        display: "flex",
        fontSize:"12px",
        flexDirection: "row",
        marginTop:"4px"
    },

    ColumnButtom: {
        width: "12.5%",
        textAlign: "center",
        display: "block",
    },

    NormalButtom: {
        marginTop:"2px",
        width: "5.5%",
        fontSize: "10.5px",
        textAlign: "center",
        display: "block",  
    },
    LargeButtom: {
        marginTop:"2px",
        width: "25%",
        fontSize: "10.5px",
        textAlign: "left",
        display: "block",  
    },
    CheckButtom: {
        width: "3.5%",
        minHeight:"15px",
        fontSize: "10.5px",
        textAlign: "center",
        display: "block",
        border: '2px',
        borderColor: 'black',
        borderStyle: 'solid', 
        marginLeft:"2px",
        marginRight:"2px", 
    },
    LineButtom: {
        marginLeft:"2px",
        marginRight:"2px",
        marginTop:"2px",
        width: "6%",
        fontSize: "10.5px",
        textAlign: "center",
        display: "block",
        borderBottom:"1px",
        borderColor: 'black',
        borderStyle: 'solid',    
    },
    BottomMargin: {
        width:"100%",
        marginTop:"10px",
        minHeight:"50px",
        
    },
    LineButtom2: {
    
        width: "18%",
        fontSize: "12px",
        textAlign: "right",
        display: "block",   
    },
    LineButtom3: {
 
        width: "18%",
        fontSize: "14px",
        textAlign: "right",
        display: "block",   
        borderTop:"1px",
        borderColor: 'black',
        borderStyle: 'solid',
        fontFamily: "Helvetica-Bold"
    },
    LineButtom2Left: {

        width: "22%",
        fontSize: "12px",
        textAlign: "left",
        display: "block",   
    },
    LineButtom3Left: {
        
        width: "22%",
        fontSize: "14px",
        textAlign: "left",
        display: "block",
        borderTop:"1px",
        borderColor: 'black',
        borderStyle: 'solid',
        fontFamily: "Helvetica-Bold"
    },
    
    
    DolarButtomLeft: {

        width: "3%",
        fontSize: "12px",
        textAlign: "left",
        display: "block",   
    },
    DolarButtomLeft2: {
        
        width: "3%",
        fontSize: "14px",
        textAlign: "left",
        display: "block",
        borderTop:"1px",
        borderColor: 'black',
        borderStyle: 'solid',
        fontFamily: "Helvetica-Bold"
    }
    ,
    ClearBottom: {
        marginLeft:"2px",
        marginRight:"2px",
        marginTop:"2px",
        width: "6.7%",
        fontSize: "10.5px",
        textAlign: "right",
        display: "block",   
    },
    ColumnaNormal2LeftHeader: {
        fontSize: "10.2px",
        width: "18%",
        textAlign: "center",
        display: "block",

    },
    ColumnaNormal2Left: {
        fontSize: "10.2px",
        width: "18%",
        textAlign: "left",
        display: "block",
        borderColor: 'black',
        borderStyle: 'solid',
        borderLeft:"2px",
        borderBottom:"1px"
 
    },


    ColumnaNormal2LeftBottom: {
        fontSize: "10.2px",
        width: "18%",
        textAlign: "center",
        display: "block",

    },

});

export default styles;